export default __webpack_public_path__ + "static/media/FBLOG-Img.2e8a2c41.png";